import React, {Component} from 'react';
import {IMAGE_RESIZE_OPTIONS} from '../constants';
import { removeLastSlashFromUrl } from './../utils';

class AvatarImage extends Component {

  constructor(props) {
    super(props);

    const {avatar} = this.props;
    this.state = {
      isImageValid: !!avatar
    };
    this.onImageError = this.onImageError.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    if(!this.state.isImageValid && nextProps.avatar){
      this.setState({
        isImageValid: true
      });
    }
  }

  onImageError() {
    this.setState({
      isImageValid: false
    });
  }

  render() {
    const {avatar, entity, style} = this.props;
    const imageResizeOptions = IMAGE_RESIZE_OPTIONS[entity];
    const {sizes, defaultClass} = imageResizeOptions;
    if(this.state.isImageValid) {
      const newAvatar = removeLastSlashFromUrl(avatar);
      return (
        <img src={`${newAvatar}${sizes[0]}`}
             srcSet={`${newAvatar}${sizes[0]} 1x, ${newAvatar}${sizes[1]} 2x`}
             alt="Avatar Image" data-pin-nopin="true"
             style={style}
             onError={this.onImageError}
        />
      );
    }

    return <div className={defaultClass} />;
  }
}

export default AvatarImage;



// WEBPACK FOOTER //
// ./src/containers/AvatarImage.js